import React from 'react';
import { Zap, Moon, Heart, Shield, Sparkles, Users } from 'lucide-react';
import { objectives } from '../data/mock';

const iconMap = {
  Zap,
  Moon,
  Heart,
  Shield,
  Sparkles,
  Users
};

const Objectives = () => {
  return (
    <section className="block-dark" id="objetivos">
      <div className="container">
        <div className="section-header">
          <h2>¿Qué puedes lograr con ZenKo?</h2>
          <p>
            Tu bienestar no debería sentirse complicado. Cuéntanos tu objetivo y te orientamos con opciones simples y accesibles para tu día a día.
          </p>
        </div>

        <div className="objectives-grid">
          {objectives.map((objective) => {
            const Icon = iconMap[objective.icon];
            return (
              <div key={objective.id} className="objective-card">
                <div className="objective-icon">
                  <Icon size={28} />
                </div>
                <h3>{objective.title}</h3>
                <p>{objective.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Objectives;